/**
 * Abas do CRUD de Candidatos que recebem registros pré-selecionados do relatório de KPIs de
 * endereços externos (utils/revalidacaoSelecao). A aba lista só esses ids (filtro `ids`, via
 * `requestFilters`), numa página só, e marca todos para o usuário revalidar em lote.
 *
 * O componente precisa ter: pageNumber, numberOfRows, itemsPerPageLastOption, serverTableLoad().
 */
export default {
  props: {
    /** { ids: Array<number> } entregue uma vez pela tela pai; ela o limpa em `selecao-aplicada`. */
    selecaoInicial: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    /** Ids do relatório separados por vírgula; vazio = sem restrição. */
    filtroIds: '',
  }),
  computed: {
    totalFiltroIds() {
      return this.filtroIds ? this.filtroIds.split(',').length : 0;
    },
  },
  methods: {
    /** Aplica o filtro e a página única; devolve true se havia seleção pendente (carregar e marcar). */
    prepararSelecaoInicial() {
      const sel = this.selecaoInicial;
      if (!sel || !Array.isArray(sel.ids) || !sel.ids.length) return false;
      this.filtroIds = sel.ids.join(',');
      this.pageNumber = 1;
      this.numberOfRows = this.itemsPerPageLastOption;
      this.$emit('selecao-aplicada');
      return true;
    },
    limparFiltroIds() {
      this.filtroIds = '';
      this.pageNumber = 1;
      this.serverTableLoad();
    },
  },
};
